import { defaultCountries, parseCountry } from "react-international-phone";

const SEARCH_ALIASES = {
  uk: "gb",
  uae: "ae",
  usa: "us",
  us: "us",
};

export function filterCountries(countries, searchQuery) {
  const query = searchQuery.trim().toLowerCase();
  if (!query) return countries;

  const aliasIso2 = SEARCH_ALIASES[query];
  const digitsOnly = query.replace(/\D/g, "");
  const plusQuery = query.startsWith("+") ? query.replace(/\s/g, "") : null;

  return countries.filter((entry) => {
    const country = parseCountry(entry);
    const name = country.name.toLowerCase();
    const iso2 = country.iso2.toLowerCase();
    const dialCode = country.dialCode;

    if (aliasIso2 && iso2 === aliasIso2) return true;
    if (name.includes(query)) return true;
    if (iso2.includes(query)) return true;
    if (plusQuery && `+${dialCode}`.startsWith(plusQuery)) return true;
    if (digitsOnly && dialCode.startsWith(digitsOnly)) return true;

    return false;
  });
}

export function splitPreferredCountries(countries, preferredCountries = []) {
  if (!preferredCountries.length) {
    return { preferred: [], rest: countries };
  }

  const preferred = [];
  const rest = [...countries];

  preferredCountries.forEach((iso2) => {
    const index = rest.findIndex(
      (entry) => parseCountry(entry).iso2 === iso2.toLowerCase(),
    );
    if (index !== -1) {
      preferred.push(rest.splice(index, 1)[0]);
    }
  });

  return { preferred, rest };
}

export function getOrderedCountries(countries, preferredCountries, searchQuery) {
  const filtered = filterCountries(countries, searchQuery);
  const { preferred, rest } = splitPreferredCountries(
    filtered,
    searchQuery ? [] : preferredCountries,
  );

  return [...preferred, ...rest];
}

export { defaultCountries };
